import React, { useEffect, useState } from "react";
import Pmgkay_Dist from "./Pmgkay_Dist";

const Pmgkay_Int = () => {
  const [activeMonth, setActiveMonth] = useState(null);
  const [currentYear, setCurrentYear] = useState(null);
  const [months, setMonths] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState("");
  const [submittedMonth, setSubmittedMonth] = useState("");
  const [submittedYear, setSubmittedYear] = useState(null);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    const fetchActiveMonth = fetch(`${process.env.REACT_APP_URL_SIDE}/api/pmgkay/activeMonth`).then(res => res.json());
    const fetchCurrentYear = fetch(`${process.env.REACT_APP_URL_SIDE}/api/pmgkay/activeYear`).then(res => res.json());
    const fetchMonths = fetch(`${process.env.REACT_APP_URL_SIDE}/api/pmgkay/getMonths`).then(res => res.json());

    Promise.all([fetchActiveMonth, fetchCurrentYear, fetchMonths])
      .then(([monthRes, yearRes, monthsRes]) => {
        setActiveMonth(monthRes);
        setSelectedMonth(monthRes.month || "");
        setCurrentYear(yearRes.year);
        setSelectedYear(yearRes.year);
        setMonths(monthsRes);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setError("Failed to fetch data.");
        setLoading(false);
      });
  }, []);

  const renderYearOptions = () => {
    const years = [];
    const currentYearValue = new Date().getFullYear();
    const startYear = 2019;
    for (let i = startYear; i <= currentYearValue; i++) {
      years.push(<option key={i} value={i}>{i}</option>);
    }
    return years;
  };

  const handleBack = () => {
    console.log("Back button clicked");
  };

  const handleSubmit = () => {
    setSubmittedMonth(selectedMonth);
    setSubmittedYear(selectedYear);
    setSubmitted(true);
  };


  return (
    <div>
      <table
        style={{
          width: "40%",
          borderCollapse: "collapse",
          margin: "20px auto",
          boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
        }}
      >
        <thead>
          <tr>
            <th
              colSpan="4"
              style={{
                backgroundColor: "black",
                color: "white",
                textAlign: "center",
                padding: "10px",
                fontSize: "18px",
              }}
            >
              PMGKAY - Rice Details
            </th>
          </tr>
        </thead>
        <tbody>
          <tr style={{ backgroundColor: "#f9f9f9" }}>
            <td style={{ padding: "10px", fontSize: "15px" }}>Month</td>
            <td>
              <select
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(e.target.value)}
                required
                style={{ padding: "5px", width: "50%", fontSize: "15px" }}
              >
                <option value="" disabled>-- Select Month --</option>
                {months.map((m) => (
                  <option key={m.month} value={m.month}>{m.name}</option>
                ))}
              </select>
            </td>

            <td style={{ padding: "10px", fontSize: "15px" }}>Year</td>
            <td>
              <select
                value={selectedYear}
                onChange={(e) => setSelectedYear(e.target.value)}
                required
                style={{ padding: "5px", width: "100%", fontSize: "15px" }}
              >
                {renderYearOptions()}
              </select>
            </td>
          </tr>

          <tr>
            <td colSpan={4} style={{ textAlign: "center", padding: "10px" }}>
              <button
                type="button"
                onClick={handleSubmit}
                style={{
                  padding: "6px 15px",
                  borderRadius: "10px",
                  border: "none",
                  backgroundColor: "black",
                  color: "white",
                  cursor: "pointer",
                  marginRight: "10px",
                }}
              >
                Submit
              </button>
              <button
                type="button"
                onClick={handleBack}
                style={{
                  padding: "6px 15px",
                  borderRadius: "10px",
                  border: "none",
                  backgroundColor: "black",
                  color: "white",
                  cursor: "pointer",
                }}
              >
                Back
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      {submitted && submittedMonth && submittedYear && (
        <Pmgkay_Dist month={submittedMonth} year={submittedYear} />
      )}
    </div>
  );
};

export default Pmgkay_Int;